var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttachmentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "attachment-icon_svg__icon",
    d: "M2.149 16.886c.92.675 1.821 1.015 2.69 1.015.217 0 .432-.021.644-.064 1.516-.301 2.31-1.587 2.315-1.6l4.479-6.096a.567.567 0 10-.915-.672l-4.506 6.138c-.006.009-.58.915-1.595 1.117-.739.148-1.56-.106-2.44-.753-2.58-1.894-1.235-3.898-1.072-4.122l7.41-10.096c.003-.005.318-.438.89-.537.525-.092 1.128.11 1.809.61.264.182.977.81 1.092 1.501.057.336-.032.657-.272.983l-6.62 9.013c-.002.004-.298.403-.735.476-.275.044-.56-.046-.873-.276-.931-.684-.448-1.514-.353-1.656l3.69-5.024a.568.568 0 10-.916-.671l-3.698 5.035c-.515.742-.779 2.214.604 3.23.566.416 1.147.577 1.732.481.9-.149 1.423-.864 1.472-.934l6.612-9.002c.425-.58.586-1.201.475-1.849C13.846 1.824 12.554.927 12.515.9c-.924-.678-1.819-.948-2.66-.803A2.578 2.578 0 008.231 1.1L.837 11.174c-.037.05-.9 1.229-.67 2.774.165 1.105.832 2.093 1.982 2.938z",
    fill: "#949494"
  })));
}

export default __webpack_public_path__ + "./fonts/attachment-icon.7183efcc049fb5d17c952f18eb4e3d88.svg";
export { SvgAttachmentIcon as ReactComponent };